import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../../../../toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { ListBlackListViewImpl } from './listblacklistview';
import { ListBlackListCSSStyleImpl } from './listblacklistcss';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import {  ListBlacklistAPIModel, ListBlacklistAPIModelImpl } from './listblacklistapimodel';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { ArabicListBlackListCSSStyleImpl } from './arabiclistblacklistcss';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';

export interface ListBlackListComponentProps extends UIComponentProps
{
    // onDeleteButtonClick(memberDetailsDto:MemberDetailsDto):void;
    onAddNumberClicked(listOfBlacklistMembers:MemberDetailsDto[]):void;
}

export interface ListBlackListComponentState extends UIComponentState
{                                                                                           
    listOfBlacklistMembers:MemberDetailsDto[];
}
export interface ListBlackListComponentHandler extends UIComponentHandler
{
    onDeleteConfirm(memberDetailsDto:MemberDetailsDto):void;
    onADDNumberClicked():void;
}

export class ListBlackListComponent extends UIComponentImpl<ListBlackListComponentProps, ListBlackListComponentState, UIDataModel> implements ListBlackListComponentHandler
{
    constructor(props: ListBlackListComponentProps)
    {
        super(props);       
        this.state = {listOfBlacklistMembers:[]};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ListBlackListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        if(applicationContext.getUserContext().getLanguage() === LanguageConst.FRENCH)
         {
            return new ListBlackListCSSStyleImpl(applicationContext);

         }
        return new ArabicListBlackListCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ListBlacklistAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentDidMount()
    {
        (this.getView() as ListBlackListViewImpl).showLoader();
        (this.getAPIModel() as ListBlacklistAPIModel).viewBlackList();
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {

        console.log("on Success of Blacklist API ,Feature:",feature);
        if(feature === APIFeatures.VIEW_BLACKLIST)
        {   
            (this.getView() as ListBlackListViewImpl).dismissLoader();

            this.setState({listOfBlacklistMembers:data as MemberDetailsDto[]});
        }
        else if(feature === APIFeatures.REMOVE_FROM_BLACKLIST)
        {
            console.log("Onsuccess of Remove Blacklist of perticular MSISDN: ",(data as MemberDetailsDto).getMsisdn());
            
            let listOfBlackList = this.state.listOfBlacklistMembers.filter((t: any)=>
            {
                return t.getMsisdn() !== (data as MemberDetailsDto).getMsisdn();
            });
             this.setState({listOfBlacklistMembers:listOfBlackList});
        }
    }


    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.VIEW_BLACKLIST)
        {
            (this.getView() as ListBlackListViewImpl).dismissLoader();
   
            (this.getView() as ListBlackListViewImpl).showPopup(this.getContext().getResources().getString(Strings.no_blacklist_at_the_moment),  AlertType.WARN,
            this.getContext().getResources().getString(Strings.ok)
           );
        }
    }

    onADDNumberClicked():void
    {
        this.props.onAddNumberClicked(this.state.listOfBlacklistMembers);
    }

    onDeleteConfirm(memberDetailsDto:MemberDetailsDto)
    {
        console.log("onDeleteConfirm of blacklist component");
         (this.getAPIModel() as ListBlacklistAPIModel).deleteBlackList(memberDetailsDto);
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklisting/listblacklistcomponent.tsx